import { useEffect, useState } from "react";

import { Account } from "@/@types/app/Account";
import { FederalUnit } from "@/@types/app/FederalUnit";
import { Module } from "@/@types/app/Module";
import { getAllModules } from "@/services/app/moduleService";
import { getPermittedCities, getPermittedFederalUnits } from "@/services/app/userService";

export function useProfessionalAccessData(module?: number, federalUnit?: string) {
	const [modules, setModules] = useState<Module[]>([]);
	const [federalUnits, setFederalUnits] = useState<FederalUnit[]>([]);
	const [cities, setCities] = useState<Account[]>([]);

	useEffect(() => {
		const loadData = async () => {
			setModules(await getAllModules());
			setFederalUnits(await getPermittedFederalUnits(module));
		};
		loadData();
	}, [module]);

	useEffect(() => {
		const loadCities = async () => {
			if (federalUnit && module) {
				setCities(await getPermittedCities(module, federalUnit));
			}
		};
		loadCities();
	}, [federalUnit, module]);

	return { modules, federalUnits, cities };
}
